import { Link } from 'react-router-dom';
import { ArrowRight, Scissors, Dumbbell, UtensilsCrossed, HardHat } from 'lucide-react';
import { ScrollReveal } from '@/hooks/useScrollReveal';

const INDUSTRIES = [
  { name: 'Barbers & Salons', icon: Scissors, href: '/web-design-barbers-bournemouth', desc: 'Online booking & style galleries' },
  { name: 'Gyms & Fitness', icon: Dumbbell, href: '/web-design-gyms-bournemouth', desc: 'Membership sign-ups & class schedules' },
  { name: 'Restaurants & Cafes', icon: UtensilsCrossed, href: '/web-design-restaurants-bournemouth', desc: 'Menus, reservations & local SEO' },
  { name: 'Trades & Construction', icon: HardHat, href: '/web-design-trades-bournemouth', desc: 'Lead generation & trust building' },
];

export default function IndustriesSection() {
  return (
    <section id="industries" data-testid="industries-section" className="py-24 md:py-32 bg-[#F8F9FA] dark:bg-[#0D0D0D]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <ScrollReveal>
          <span className="text-xs sm:text-sm font-bold uppercase tracking-[0.2em] text-slate-400 block mb-4">
            Local Expertise
          </span>
          <h2 className="font-['Outfit'] text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-[#0A0A0A] dark:text-white mb-4 max-w-lg">
            What Industries Does UI DESIGNS Work With?
          </h2>
          <p className="text-base sm:text-lg leading-relaxed text-slate-600 dark:text-slate-400 mb-16 max-w-lg">
            Helping Bournemouth businesses get more customers online — from high streets to home services.
          </p>
        </ScrollReveal>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {INDUSTRIES.map((industry, i) => (
            <ScrollReveal key={industry.name} delay={i * 100}>
              <Link
                to={industry.href}
                data-testid={`industry-card-${i}`}
                className="group block bg-white dark:bg-[#111111] border border-slate-200 dark:border-white/10 rounded-2xl p-8 glow-hover hover:border-[#00E5FF]/30 dark:hover:border-[#00E5FF]/30 transition-all"
              >
                <div className="w-10 h-10 rounded-lg bg-[#0A0A0A] dark:bg-[#8B5CF6]/20 flex items-center justify-center mb-5 group-hover:bg-[#00E5FF] dark:group-hover:bg-[#8B5CF6] transition-colors duration-300">
                  <industry.icon className="w-4 h-4 text-white group-hover:text-white transition-colors" />
                </div>
                <h3 className="font-['Outfit'] text-lg font-semibold tracking-tight text-[#0A0A0A] dark:text-white mb-1">
                  {industry.name}
                </h3>
                <p className="text-sm text-slate-500 dark:text-slate-400 mb-4">
                  {industry.desc}
                </p>
                <span className="inline-flex items-center gap-1.5 text-xs font-semibold text-[#00B4D8] group-hover:gap-2.5 transition-all">
                  Learn more <ArrowRight className="w-3 h-3" />
                </span>
              </Link>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}
